import type { FaireProductEntity } from "../../entity_types/product";

export const p_tqrs872t99: FaireProductEntity = {
  token: "p_tqrs872t99",
  type: "product",
  name: "Gold Rush",
  brandToken: "b_jkwarag9fz",
  brandName: "Headwaters BBQ",
  imageUrl:
    "https://cdn.faire.com/fastly/acb81df6ccba11a472540c86f972756f7bbcd757bbab09bcd1b9686fc6a9c52d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/513a01fde153d740da590b587e705538fc2dbb0d0dd9f6ac581df4d16509d3ce.png",
    "https://cdn.faire.com/fastly/60a20dd1c0ca87b1bbee7c194c39dceeed138408b86d036d54c1a0df3cd9caf0.png",
    "https://cdn.faire.com/fastly/89abaebe6dc323c5ab37bb6b8f159c246c893123a015401fbb8cfdb885c10abe.jpeg",
  ],
  priceDollars: 4.59,
  description:
    "South Carolina inspired tangy mustard and pepper sauce.  Perfect on all kinds of pork, chicken, and salmon.  It's our preferred marinade and bbq binder.\nSlow cooker chicken tacos:  Add breasts and thighs to your slow cooker.  Add some Ghost Town Gold sauce and Pipestone Poultry rub.  Cook until shredable.  Add more sauce and rub.  Serve on tortillas with sour cream (or Boiling River crema), salsa, and your favorite toppings.",
  tags: [],
  msrpDollars: 7.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:11.924Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
